import React, { useState } from "react";
import "../loginPage/LoginPage.styles.css";
import { Link } from "react-router-dom";
import darkLogo from "../../assets/images/dark-logo.png";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AnimationSpinner from "../../AnimationSpinner";
import LoginImage from "../../assets/images/loginPage/Flipbook.jpg";
import { BsFillPersonFill } from "react-icons/bs";
import { handleInvalidToken } from "../../AuthUtils";
import { toast } from "react-toastify";

const ForgotPassword = ({ base_url }) => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            let isValid = true;
            if (!email) {
                toast.error("Email is required.");
                isValid = false;
            }
            if (!isValid) {
                return;
            }
            setLoading(true);

            const formData = new FormData();
            formData.append("action", "forgotPasswordRequest");
            formData.append("email", email);

            axios
                .post(`${base_url}api/user/forgot-password`, formData)
                .then((response) => {
                    if (response.data.status === true) {
                        setLoading(false);
                        toast.success("Check your inbox for the request.");
                    } else {
                        setLoading(false);
                        if (response.data.reset === true) {
                            handleInvalidToken(navigate);
                            return;
                        }
                        toast.error(response.data.message);
                    }
                });
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message ||
                error.message ||
                "Something went wrong. Please try again.");
        }
    };

    return (
        <>
            <div className="min-vh-100 d-flex login-gradient align-items-center justify-content-center p-4"  style={{ background: "linear-gradient(233deg, rgba(242, 234, 234, 0.91) 19%, rgba(247, 247, 247, 0.94) 85%)" }}>
                <div className="main-login-container rounded-3 overflow-hidden position-relative shadow" >
                    <div className="row h-100 g-0 login-content">
                        {/* left side -image */}
                        <div className="col-lg-6 d-none d-lg-block position-relative">
                            <div className="login-img-container">
                                <img
                                    src={LoginImage}
                                    alt="Team collaboration"
                                    layout="fill"
                                    className="rounded-end-3"
                                />
                            </div>
                        </div>
                        {/* left Side - Form */}
                        <div className="left-login-container col-lg-6 col-md-10 mx-auto p-4 p-lg-5">
                            <div className="mb-4 mb-lg-4 text-center">
                                <div className="loginPage-logo-container mx-auto">
                                    <img src={darkLogo} alt="Book Flow" />
                                </div>
                            </div>

                            <div className="mb-4 text-center">
                                <h1 className="h4">Forgot your password?</h1>
                                <p className="text-muted">Enter your email to receive a password reset link.</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label small text-muted fw-semibold">
                                        Email
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            id="email"
                                            name="email"
                                            placeholder="xyz@gmail.com"
                                            className="form-control login"
                                            value={email}
                                            onChange={({ target: { value } }) =>
                                                setEmail(value)
                                            }
                                        />
                                        <div className="login-input-icon position-absolute">
                                            <BsFillPersonFill />
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: "rgb(111, 9, 81)" }}>
                                    Send Request
                                </button>
                            </form>

                            <div className="mt-3">
                                <span className="go-back">Go back to </span>
                                <Link to="/login" className="login-link">
                                    Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;